"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelStateProxy = void 0;
var tslib_1 = require("tslib");
var CollectionModelStateProxy = /** @class */ (function () {
    function CollectionModelStateProxy(state) {
        this.frozen = false;
        this.internalState = state;
    }
    Object.defineProperty(CollectionModelStateProxy.prototype, "loader", {
        get: function () { return this.internalState.loader; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "id", {
        get: function () { return this.internalState.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "instanceId", {
        get: function () { return this.internalState.instanceId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "uuid", {
        get: function () { return this.internalState.uuid; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "revision", {
        get: function () { return this.internalState.revision; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "jobId", {
        get: function () { return this.internalState.jobId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "updatedAt", {
        get: function () { return this.internalState.updatedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "updatedBy", {
        get: function () { return this.internalState.updatedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "createdAt", {
        get: function () { return this.internalState.createdAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "collectedAt", {
        get: function () { return this.internalState.collectedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "collectedBy", {
        get: function () { return this.internalState.collectedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "collectedWith", {
        get: function () { return this.internalState.collectedWith; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelStateProxy.prototype, "assignedTo", {
        get: function () { return this.internalState.assignedTo; },
        enumerable: false,
        configurable: true
    });
    CollectionModelStateProxy.prototype.reset = function () {
        this.fields.clear();
        this.geometries.clear();
    };
    CollectionModelStateProxy.prototype.getFieldValue = function (fieldId) {
        if (this.fields.has(fieldId)) {
            return this.fields.get(fieldId);
        }
        return this.internalState.getFieldValue(fieldId);
    };
    CollectionModelStateProxy.prototype.setFieldValue = function (fieldId, state) {
        var internalValue = this.internalState.getFieldValue(fieldId);
        if (JSON.stringify(state) === JSON.stringify(internalValue)) {
            this.fields.delete(fieldId);
        }
        else {
            this.fields.set(fieldId, state);
        }
    };
    CollectionModelStateProxy.prototype.hasFieldValue = function (fieldId) {
        return this.getFieldValue(fieldId) != null;
    };
    CollectionModelStateProxy.prototype.getCapture = function (captureId) {
        return this.internalState.getCapture(captureId);
    };
    CollectionModelStateProxy.prototype.getCalibration = function (calibrationId) {
        return this.internalState.getCalibration(calibrationId);
    };
    CollectionModelStateProxy.prototype.getGeometry = function (captureId) {
        return this.internalState.getGeometry(captureId);
    };
    CollectionModelStateProxy.prototype.getCollection = function (uuid) {
        return this.internalState.getCollection(uuid);
    };
    /**
     * @deprecated This method can create race conditions; use `getCollectionModelAsync()` instead.
     */
    CollectionModelStateProxy.prototype.getCollectionModel = function (collectionId) {
        return this.internalState.getCollectionModel(collectionId);
    };
    CollectionModelStateProxy.prototype.getCollectionModelAsync = function (collectionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.internalState.getCollectionModelAsync(collectionId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectionModelStateProxy.prototype.freeze = function () {
        throw new Error('Cannot freeze edit state');
    };
    return CollectionModelStateProxy;
}());
exports.CollectionModelStateProxy = CollectionModelStateProxy;
//# sourceMappingURL=collection.state.proxy.js.map